export default __webpack_public_path__ + "static/media/proceed.fe11a6da.svg";